<div class="banner" role="banner">
    <h1>{{ 'split.transactions.page.title' | translate }}</h1>
</div>
<fgb-account-nav></fgb-account-nav>

<div class="container">
    <fgb-split-transaction-history></fgb-split-transaction-history>
</div>
  